import {createStore} from 'redux';
import {persistStore, autoRehydrate} from 'redux-persist'
import { composeWithDevTools } from 'redux-devtools-extension';


// import the root reducer
import rootReducer from './reducers/';

// import page data
import pagesBasis from './data/basis/pages';
import pagesHuisartsen from './data/huisartsen/pages';
import pagesOuderenzorg from './data/ouderenzorg/pages';
import pagesPubliekeGezondheidszorg from './data/publiekeGezondheidszorg/pages';
import pagesZorgverzekering from './data/zorgverzekering/pages';
import pagesMini from './data/mini/pages';
import pagesGeneesmiddelenzorg from './data/geneesmiddelenzorg/pages';

const pages = pagesBasis.concat(pagesHuisartsen, pagesOuderenzorg, pagesPubliekeGezondheidszorg, pagesZorgverzekering, pagesMini, pagesGeneesmiddelenzorg);
// const pages = pagesBasis.concat(pagesHuisartsen, pagesOuderenzorg, pagesPubliekeGezondheidszorg, pagesZorgverzekering, pagesMini);

// create an object for the default data
let defaultState = { pages };
if (typeof localStorage !== 'undefined'){
	const access = localStorage.getItem('reduxPersist:access') ? JSON.parse(localStorage.getItem('reduxPersist:access')) : [];
	const organisation = localStorage.getItem('reduxPersist:organisation') ? JSON.parse(localStorage.getItem('reduxPersist:organisation')) : '';
	defaultState = { pages, access, organisation };
}

// add `autoRehydrate` as an enhancer to your store (note: `autoRehydrate` is not a middleware)
const store = createStore(
	rootReducer,
	defaultState,
	composeWithDevTools(
	autoRehydrate()
));

// begin periodically persisting the store
persistStore(store, { whitelist: ['access','organisation']})

export default store;
